<template>
  <div class="page-wrapper">
    <div class="section-title">
      <div class="left">
        <span style="font-size: 30px">
          <svgIcon iconClass="merchants" class="icon" />
        </span>

        <span class="title-name">线索登记</span>
      </div>
      <div class="right"></div>
    </div>
    <div class="project-table-wrapper">
      <merchantsForm @onSuccess="handleFromSubmitSuccess" />
    </div>
  </div>
</template>

<script>
import merchantsForm from "./components/form";
export default {
  name: "merchantsList",
  components: {
    merchantsForm,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handleFromSubmitSuccess() {},
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.page-wrapper {
  text-align: left;
  /deep/ {
    .el-dialog__header {
      text-align: left;
    }
    .el-dialog__body {
      background-color: #f6f7f7;
    }
  }
  .limit-winth {
    width: 100%;
    font-size: 14px;
    height: 18px;
    line-height: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .project-table-wrapper {
    width: 100%;
    padding-top: 30px;
  }
  .section-title {
    width: 100%;
    padding: 19px 0 26px 0;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    .left {
      flex: 1;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .right {
      flex: 1;
      text-align: right;
    }
    .title-name {
      font-size: 24px;
      color: #4a4a4a;
      font-weight: bold;
      margin-left: 8px;
    }
  }
}
</style>